import React from "react";
import { MODULES } from "@/pages/modules";
import CrudModule from "@/components/CrudModule";

export default function ModulePage({ moduleKey }) {
  const config = MODULES[moduleKey];
  if (!config) return <div className="text-slate-500">Module not found.</div>;
  return <CrudModule key={moduleKey} config={config} />;
}
